export const createPluginOptions = <T>() => {
	return <S extends T>(options: S) => options;
};
